import React from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../ui/select';
import { Loader2 } from 'lucide-react';

export function CreateAccountDialog({ open, onClose, onSubmit, accountForm, setAccountForm, submitting }) {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Create Account</DialogTitle>
          <DialogDescription>Create a new restaurant account</DialogDescription>
        </DialogHeader>
        <form onSubmit={onSubmit} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="name">Owner Name</Label>
            <Input
              id="name"
              value={accountForm.name}
              onChange={(e) => setAccountForm(prev => ({ ...prev, name: e.target.value }))}
              required
              data-testid="account-name-input"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="email">Owner Email</Label>
            <Input
              id="email"
              type="email"
              value={accountForm.email}
              onChange={(e) => setAccountForm(prev => ({ ...prev, email: e.target.value }))}
              required
              data-testid="account-email-input"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="password">Password</Label>
            <Input
              id="password"
              type="password"
              value={accountForm.password}
              onChange={(e) => setAccountForm(prev => ({ ...prev, password: e.target.value }))}
              required
              data-testid="account-password-input"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="brand_name">Brand Name</Label>
            <Input
              id="brand_name"
              value={accountForm.brand_name}
              onChange={(e) => setAccountForm(prev => ({ ...prev, brand_name: e.target.value }))}
              required
              data-testid="account-brand-input"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="plan_type">Plan Type</Label>
            <Select
              value={accountForm.plan_type}
              onValueChange={(value) => setAccountForm(prev => ({ ...prev, plan_type: value }))}
            >
              <SelectTrigger data-testid="account-plan-select">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="free">Free (No Stripe)</SelectItem>
                <SelectItem value="single">Single Location</SelectItem>
                <SelectItem value="multi">Multi Location</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div className="flex gap-3 pt-4">
            <Button type="button" variant="outline" className="flex-1" onClick={onClose}>
              Cancel
            </Button>
            <Button type="submit" className="flex-1" disabled={submitting} data-testid="account-submit-btn">
              {submitting ? <Loader2 className="h-4 w-4 animate-spin" /> : 'Create Account'}
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
